/**
 * Relationship types and interfaces
 */
// Relationship access levels for property management
export var RelationshipAccessLevel;
(function (RelationshipAccessLevel) {
    RelationshipAccessLevel["MANAGER"] = "MANAGER";
    RelationshipAccessLevel["TENANT"] = "TENANT";
    RelationshipAccessLevel["OWNER"] = "OWNER";
    RelationshipAccessLevel["VENDOR"] = "VENDOR";
})(RelationshipAccessLevel || (RelationshipAccessLevel = {}));
export const RELATIONSHIP_ACCESS_LEVELS = Object.values(RelationshipAccessLevel);
//# sourceMappingURL=relationship.js.map